import { render, staticRenderFns } from "./Footer2.vue?vue&type=template&id=1e5c904c&scoped=true"
import script from "./Footer2.vue?vue&type=script&lang=js"
export * from "./Footer2.vue?vue&type=script&lang=js"
import style0 from "./Footer2.vue?vue&type=style&index=0&id=1e5c904c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e5c904c",
  null
  
)

export default component.exports